import { Route, Routes } from 'react-router';
import './App.css';
import Navbar from './Navbar';
import Home from './pages/Home';
import Contact from './pages/Contact';
import Development from './pages/Development';

export function App() {
  return (
    <>
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/dev" element={<Development />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
    </>
  )
}
